module.exports = __webpack_public_path__ + "static/media/icon-github.2f91007e.svg";